<template>
    <div>
        <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center no-padding-bottom">
            <span class="mask bg-gradient-danger opacity-8"></span>
        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col-xl-12 order-xl-1">
                    <br><br><br>
                    <card shadow type="secondary">
                        <div slot="header" class="bg-white border-0">
                            <div class="row align-items-center">

                                <div class="col-8">
                                    <h3 class="mb-0 text-uppercase">{{ this.$route.name }}</h3>
                                    <br>
                                    <span class="text-danger">
                                        Kindly enter a valid RRR (must have been paid for) and click on Proceed Now
                                        to continue with your Application
                                    </span>
                                </div>
                                <div class="col-4 text-right">
                                    <a :href="websiteUrl" class="btn btn-sm btn-danger text-white">
                                       <i class="fa fa-reply"></i> Home
                                    </a>
                                </div>
                            </div>
                        </div>

                        <div class="row" v-if='! showErrorStatus && ! isLoadingBlade'>
                            <div :class="'col-lg-'+(showCountry ? 4 : 6)">
                                <base-input alternative=""
                                    label="Assessment Category"
                                    required
                                >
                                    <select
                                        class="form-control form-control-alternative"
                                        v-model="category"
                                        @change="emptyField"
                                    >
                                        <option :value="null" disabled selected>--- Select One ---</option>
                                        <option
                                            v-for="cat in categories"
                                            :key="cat.id"
                                            :value="cat.id"
                                        >
                                            {{ cat.title }}
                                            <em v-if="cat.description">({{ cat.description }})</em>
                                        </option>
                                    </select>
                                </base-input>
                            </div>

                            <div class="col-lg-4" v-if="showCountry">
                                <base-input alternative=""
                                    label="Country of Medical School (Dental Applicants Only)"
                                    required
                                >
                                    <autocomplete
                                        v-if="locations && locations.countries"
                                        input-class="form-control form-control-alternative"
                                        placeholder="Type Country"
                                        showNoResults
                                        :source="locations.countries"
                                        v-model="country"
                                    >
                                    </autocomplete>
                                </base-input>
                            </div>

                            <div :class="'col-lg-'+(showCountry ? 4 : 6)">
                                <base-input alternative=""
                                    label="RRR"
                                    placeholder="Enter Valid RRR"
                                    input-classes="form-control-alternative"
                                    v-model="rrr"
                                    type="number"
                                    required
                                />
                            </div>
                        </div>

                        <div class="col-lg-12" v-if="isLoadingBlade">
                            <div class="d-flex justify-content-center">
                                <img :src="loadingBladeUrl" />
                            </div>
                        </div>

                        <div class="col-lg-12 text-center" v-if='showErrorStatus && ! isLoadingBlade'>
                            <base-alert :type="errorType">
                                <!-- <span class="alert-inner--icon"><i class="ni ni-like-2"></i></span> -->
                                <span class="alert-inner--text">
                                    <h2 class="text-white">{{errorMsg}}</h2>
                                </span>
                            </base-alert>
                        </div>

                        <div v-if='! showErrorStatus && ! isLoadingBlade'>
                            <hr>
                            <router-link
                                to="/assessment-exam"
                                class="btn btn-danger"
                            >
                                <i class="fa fa-arrow-left"></i>
                                Go Back
                            </router-link>

                            <base-button
                                type="success"
                                class="right"
                                :disabled="showProceedButton"
                                @click="getRRRStatus()"
                            >
                                {{ isloading ? 'Please Wait...' : 'Proceed Now'}}
                                <i class="fa fa-arrow-right"></i>
                            </base-button>
                            <br><br><br><br>
                        </div>

                    </card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import swal from 'sweetalert2';// import sweet alert
    import Autocomplete from 'vuejs-auto-complete';

    export default {
        name: 'AssessmentRegistrationApp',
        components: {
            Autocomplete
        },
        data() {
            return {
                categories: [],
                rrr: null,
                category: null,
                country: null,
                isloading: false,
                showErrorStatus: false,
                errorType: null,
                errorMsg: null,
                isLoadingBlade: false
            }
        },
        computed: {
            ...mapGetters(['websiteUrl', 'loadingBladeUrl', 'locations']),
            showCountry() {// for dental only
                return (this.category && ((this.category == 2) || (this.category == 4))) ? true : false;
            },
            showProceedButton() {
                if(this.showCountry) {
                    return (this.rrr && this.category && this.country) ? false : true;
                } else {
                    return (this.rrr && this.category) ? false : true;
                }
            }
        },
        methods: {
            ...mapActions(['getAssessmentRrrStatus', 'getAssessmentTypes', 'getLocations']),
            clearStorage() {
                localStorage.removeItem('applicantId');
            },
            emptyField() {
                this.country = null;
            },
            loadAssessmentTypes() {
                this.isLoadingBlade = true;
                this.categories = [];
                let data = { 'type' : true };
                this.getLocations();
                this.getAssessmentTypes(data).then((res) => {
                    this.categories = res.types;
                    this.showErrorStatus = false;
                    this.isLoadingBlade = false;
                    this.clearStorage();
                }).
                catch(() => {
                    this.showErrorStatus = true;
                    this.isLoadingBlade = false;
                    this.errorMsg = "Network Failure!, kindly reload the page...";
                    this.errorType = 'danger';
                });
            },
            getRRRStatus() {
                if(this.rrr) {
                    this.isloading = true;
                    this.preloader();
                    let data = { rrr : this.rrr, category: this.category, country: this.country, type : 'late-register' };
                    this.getAssessmentRrrStatus(data).then((res) => {
                        this.isloading = false;
                        if(res.status) {
                            swal.close();
                            localStorage.setItem('applicantId', res.applicant_id);
                            return window.location.href = '/assessment/application-form';
                        } else {
                            this.isloading = false;
                            swal.fire("Verification Failed!", res.msg, "warning");
                        }
                    }).
                    catch(() => {
                        this.isloading = false;
                        let msg = "Network Failure!, kindly reload the page...";
                        swal.fire("Error Ocurred!", msg, "warning");
                    });
                } else {
                    let msg = 'Kindly fill the necessary field(s) and try again...';
                    swal.fire("Empty field(s)!", msg, "warning");
                }
            },
            preloader() {
                return  swal.fire({
                    title: 'Please Wait...',
                    html: 'Trying to fetch data from <b>server</b>',
                    // timer: 2000,
                    timerProgressBar: true,
                    onBeforeOpen: () => {
                        swal.showLoading()
                    },
                });
            }
        },
        created() {
            this.loadAssessmentTypes();
        }
    }
</script>

<style scoped>
    .no-padding-bottom {
        padding-bottom: 0rem !important
    }
    .right {
        float: right;
    }
</style>

<style>
    .form-control-label {
        width: 100%;
    }
    .height-50 {
        height: 50px;
    }
    .borderLine {
        border: 1px solid #ededed;
    }
</style>